<template>
  <div class="data-table-container">
    <el-backtop target="#app" style="width: auto" :right="30">
      <div
          style="{
        height: 100%;
        width: 100%;
        background-color: #f2f5f6;
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        line-height: 40px;
        padding:5px;
        color: #1989fa;
        border-radius: 5px;
      }"
      >
        顶部
      </div>
    </el-backtop>
    <!-- 主数据表格视图 -->
    <template v-if="!showingCompanyNews">
      <el-form v-show="fold" :inline="true" :model="filterForm" class="filter-form-new" size="small">
        <div style="width: 100%;text-align: center;">
          <span style="font-size: 22px;margin-top: 10px;padding-right: 0">筛选条件</span>
        </div>

        <div style="width: 100%;text-align: center;">
            <el-button type="text" @click="handleUnFold">
              <i class="el-icon-caret-bottom"></i>
              <span>展开</span>
            </el-button>
        </div>
      </el-form>
      <!-- 筛选表单 -->
      <el-form v-show="!fold" :inline="true" :model="filterForm" class="filter-form" size="small">
        <div class="grid">
          <span>公司</span>
          <div class="form-item">
            <el-input v-model="filterForm.company" placeholder="请输入公司名称"></el-input>
          </div>
          <span>来源</span>

          <div class="form-item">
            <el-input v-model="filterForm.source" placeholder="请输入来源"></el-input>
          </div>
          <span>标题</span>

          <div  class="form-item">
            <el-input v-model="filterForm.title" placeholder="请输入标题"></el-input>
          </div>
          <span>标签</span>

          <div  class="form-item">
            <el-input v-model="filterForm.tag" placeholder="请输入标签"></el-input>
          </div>
          <span>完成状态</span>

          <div  class="form-item">
            <el-select v-model="filterForm.finish" placeholder="请选择">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="已完成" :value="1"></el-option>
              <el-option label="未完成" :value="0"></el-option>
            </el-select>
          </div>
          <span>日期范围</span>

          <div class="form-item date-range">
            <el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
        </div>

        <div class="flex">
            <el-tooltip content="筛选去除未知公司名" placement="left">
              <el-switch
                  style="float: left;display: inline-block;"
                  v-model="filterForm.filterCompany"
                  active-color="#13ce66"
                  active-text="开启筛选"
                  inactive-text="关闭筛选"
                  inactive-color="#ff4949">
              </el-switch>
            </el-tooltip>
            <div class="right">
              <el-button  type="primary" @click="handleSearch">查询</el-button>
              <el-button  @click="handleReset">重置</el-button>
            </div>


        </div>


        <el-button type="text" @click="handleFold" style="width: 100%;margin-bottom: 5px;">
          <i class="el-icon-caret-top"></i>
          <span style="padding-right: 0">收起</span>
        </el-button>

      </el-form>

      <!-- 数据表格 -->
      <el-table
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
          @sort-change="handleSortChange">
        <el-table-column
            prop="date"
            label="日期"
            width="120"
            sortable="custom"
        >
          <template v-slot="scope">
            {{scope.row.date | formatDate}}
          </template>
        </el-table-column>
        <el-table-column
            prop="company"
            label="公司"
            width="180">
          <template v-slot="scope">
            <el-button
                type="text"
                @click="showCompanyNews(scope.row.company)">
              {{ scope.row.company }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
            prop="title"
            label="标题"
            show-overflow-tooltip>
          <template v-slot="scope">
            <el-link type="primary" :href="scope.row.link">{{ scope.row.title }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
            prop="source"
            label="来源"
            width="120">
        </el-table-column>
        <el-table-column
            prop="tag"
            label="标签"
            width="100">
          <template slot-scope="scope">
            <el-tag :type="getTagType(scope.row.tag)">{{ scope.row.tag }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            prop="finish"
            label="完成状态"
            width="100">
          <template v-slot="scope">
            <el-tag :type="scope.row.finish ? 'success' : 'error'">
              {{ scope.row.finish ? '已完成' : '未完成' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <div class="pagination-container">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </template>

    <!-- 公司新闻视图 -->
    <template v-else>
      <div class="company-news-header">
        <el-page-header
            @back="handleBack"
            :content="companyFilterForm.company + '相关新闻'">
        </el-page-header>
      </div>

      <!-- 新闻筛选表单 -->
      <el-form :inline="true" :model="companyFilterForm" class="filter-form" size="small">
        <div class="grid">
          <span>来源</span>

          <div class="form-item">
            <el-input v-model="companyFilterForm.source" placeholder="请输入来源"></el-input>
          </div>
          <span>标题</span>

          <div  class="form-item">
            <el-input v-model="companyFilterForm.title" placeholder="请输入标题"></el-input>
          </div>
          <span>标签</span>

          <div  class="form-item">
            <el-input v-model="companyFilterForm.tag" placeholder="请输入标签"></el-input>
          </div>
          <span>完成状态</span>

          <div  class="form-item">
            <el-select v-model="companyFilterForm.finish" placeholder="请选择">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="已完成" :value="1"></el-option>
              <el-option label="未完成" :value="0"></el-option>
            </el-select>
          </div>
          <span>日期范围</span>

          <div class="form-item date-range">
            <el-date-picker
                v-model="companyDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
          <span></span>
          <div></div>
        </div>
        <el-divider></el-divider>
        <div style="float:right;">
          <el-form-item>
            <el-button type="primary" @click="handleCompanySearch">查询</el-button>
            <el-button @click="handleCompanyReset" style="margin-right: 20px">重置</el-button>
          </el-form-item>
        </div>
        <div style="clear:both;"></div>
      </el-form>
      <el-row style="margin-bottom: 20px">
        <el-col :span="24">
          <el-card shadow="always" style="text-align: center">
            <el-pagination
                @size-change="handleNewsSizeChange"
                @current-change="handleNewsCurrentChange"
                :current-page="companyCurrentPage"
                :page-sizes="[5, 10, 20, 50]"
                :page-size="companyPageSize"
                :pager-count="7"
                layout="total, sizes, prev, pager, next, jumper"
                :total="companyTotal">
            </el-pagination>
          </el-card>

        </el-col>
      </el-row>
      <div class="company-news-container">
        <el-timeline :reverse="true" v-loading="loading2">
          <el-timeline-item
              v-for="(news, index) in specialCompanyNews"
              :key="index"
              :timestamp="news.date | formatDate"
              :type="getTimelineItemType(news.tag)">
            <el-card class="news-card" style="position: relative">
              <div class="news-header">
                <h3>{{ news.title }}</h3>
                <el-tag size="small" :type="getTagType(news.tag)" style="position: absolute;top: 10px;right: 20px;padding: 2px">{{ news.tag }}</el-tag>
              </div>
              <div class="news-content">{{ news.content }}</div>
              <div class="news-footer">
                <span class="news-source">来源：{{ news.source }}</span>
                <el-button
                    style="position: absolute;bottom: 10px;right: 20px"
                    type="text"
                    @click="skipLink(news.link)">
                  查看原文
                </el-button>
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'

export default {

  name: 'MyTableNew',
  props:['company'],
  data() {
    return {
      //是否折叠
      fold:false,
      //过滤组件
      filterForm: {
        company: '',
        source: '',
        title: '',
        tag: '',
        finish: null,
        startDate: '',
        endDate: '',
        pageNumber: 1,
        pageSize: 10,
        orderDate:false,
        filterCompany:true
      },
      //主界面日期范围
      dateRange: [],
      //主界面表格显示的数据
      tableData: [],
      //主界面分页组件属性
      total: 0,//总页数
      currentPage: 1,//当前页
      pageSize: 10,//一次显示的数量


      //加载条显示
      loading: false,

      //展示公司详情界面的开关
      showingCompanyNews: false,
      //公司详情界面的过滤表单
      companyFilterForm: {
        company:'',
        source: '',
        title: '',
        tag: '',
        finish: null,
        startDate: '',
        endDate: '',
        pageNumber: 1,
        pageSize: 10,
        orderDate:true
      },
      //公司详情界面日期范围
      companyDateRange:[],
      // 存储公司点进去之后展示的新闻
      specialCompanyNews: [],
      // 公司详情界面的分页组件数据
      companyCurrentPage: 1,
      companyPageSize: 10,
      companyTotal: 0,
      loading2:false
    }
  },
  computed: {
    ...mapState(['baseUrl'])
  },
  methods: {
    //展开逻辑
    handleUnFold(){
      this.fold=false
    },
    //折叠逻辑
    handleFold(){
      this.fold = true
    },
    skipLink(link){
      window.open(link, '_blank')
    },
    cleanObject(obj) {
      const result = {};
      Object.keys(obj).forEach(key => {
        const value = obj[key];
        // 检查值是否有效，这里我们认为非空字符串、非null值、非undefined值是有效的
        if (value !== '' && value !== null && value !== undefined) {
          result[key] = value;
        }
      });
      return result;
    },
    // 更新主表格数据
    async fetchData() {
      this.loading = true
      //获取数据的逻辑
      this.filterForm.startDate=this.dateRange[0]
      this.filterForm.endDate=this.dateRange[1]
      const cleanedFilterForm = this.cleanObject(this.filterForm);
      console.log("提交axios参数",cleanedFilterForm)
      axios.get(`${this.baseUrl}/news/query/light`, {params: cleanedFilterForm}).then(response => {
        this.tableData=response.data.data;
        this.total=response.data.total;
      }).catch(error=>{
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败，请稍后重试')
      }).finally(()=>{
        this.loading = false;
      })
    },
    async fetchCompanyData() {
      this.loading2 = true
      this.companyFilterForm.startDate=this.companyDateRange[0]
      this.companyFilterForm.endDate=this.companyDateRange[1]
      const cleanedFilterForm = this.cleanObject(this.companyFilterForm);
      console.log("提交axios参数",cleanedFilterForm)
      axios.get(`${this.baseUrl}/news/query/light`, {params: cleanedFilterForm}).then(response => {
        this.specialCompanyNews=response.data.data;
        this.companyTotal=response.data.total;
        console.log(this.specialCompanyNews)
      }).catch(error=>{
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败，请稍后重试')
      }).finally(()=>{
        this.loading2 = false;
      })
    },
    //主数据表格排序发生改变
    handleSortChange({ order }) {
      if (order==="ascending"){
        this.filterForm.orderDate=true
      }else if(order==="descending"){
        this.filterForm.orderDate=false
      }else {
        this.filterForm.orderDate=null
      }
      this.fetchData()
      // '主数据表格排序发生改变: date ascending\n' +
      // '主数据表格排序发生改变: date descending\n' +
      // '主数据表格排序发生改变: date null'
      // console.log("主数据表格排序发生改变:",prop, order)
      // console.log("主数据表格排序发生改变:",typeof prop, typeof order)
    },
    // 主界面筛选表格的查询按钮
    handleSearch() {
      this.currentPage = 1
      this.pageSize = 10
      this.filterForm.pageNumber=1
      this.filterForm.pageSize=10
      this.fetchData()
    },
    // 主页面筛选重置按钮方法
    handleReset() {
      this.filterForm = {
        company: '',
        source: '',
        title: '',
        tag: '',
        finish: null,
        startDate: '',
        endDate: '',
        pageNumber: 1,
        pageSize: 10
      }
      this.dateRange = []
      this.fetchData()
    },
    // 公司详情页面筛选重置按钮方法
    handleCompanyReset() {
      this.filterForm = {
        company: '',
        source: '',
        title: '',
        tag: '',
        finish: null,
        startDate: '',
        endDate: '',
        pageNumber: 1,
        pageSize: 10
      }
      this.dateRange = []
      this.fetchData()
    },
    // 主界面分页组件行为
    handleSizeChange(val) {
      this.pageSize = val
      this.filterForm.pageSize = val
      this.currentPage = 1
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.filterForm.pageNumber = val
      this.currentPage = val
      this.fetchData()
    },
    //跳转到指定公司展示的逻辑
    showCompanyNews(company) {

      this.loading = true
      this.companyFilterForm.company = company
      // 这里添加获取公司新闻方法调用
      setTimeout(() => {
        this.fetchCompanyData()
        this.loading = false
        this.showingCompanyNews = true
      })
    },
    //退出公司详情逻辑
    handleBack() {
      this.showingCompanyNews = false
      this.fetchData()
    },
    //tag标签颜色
    getTimelineItemType(tag) {
      switch(tag) {
        case '正面新闻':
          return 'success'
        case '负面新闻':
          return 'danger'
        default:
          return 'info'
      }
    },
    getTagType(tag) {
      switch(tag) {
        case '正面新闻':
          return 'success'
        case '负面新闻':
          return 'danger'
        default:
          return 'info'
      }
    },
    // 公司详情确认按钮
    handleCompanySearch() {
      this.companyCurrentPage = 1
      this.companyPageSize = 10
      this.companyFilterForm.pageNumber=1
      this.companyFilterForm.pageSize=10
      this.fetchCompanyData()
    },
    // 公司详情分页组件行为
    handleNewsSizeChange(val) {
      this.companyPageSize = val
      this.companyCurrentPage = 1
      this.companyFilterForm.pageSize=val
      this.fetchCompanyData()
      console.log('公司详情分页组件行为')
    },
    handleNewsCurrentChange(val) {
      this.companyCurrentPage = val
      this.companyFilterForm.pageNumber=val
      this.fetchCompanyData()
      console.log('公司详情当前页切换')
    }
  },
  filters:{
    formatDate([year, month, day]){
      // 确保月份和日期是两位数
      const formattedMonth = month.toString().padStart(2, '0');
      const formattedDay = day.toString().padStart(2, '0');

      // 使用模板字符串构建日期
      return `${year}-${formattedMonth}-${formattedDay}`;
    },
    dateStringToTimestamp(dateString) {
      // 创建一个Date对象
      let date = new Date(dateString);
      // 返回时间戳（单位：毫秒）
      return date.getTime();
    },
    numToString(num){
      return String(num)
    }
  },
  //路由显示行为
  mounted() {
    console.log(this)
    if (this.company){
      this.showingCompanyNews = true
      this.companyFilterForm.company=this.company
      this.fetchCompanyData()
    }else{
      this.fetchData();
    }
  },
}
</script>

<style scoped>
.grid{
  display: grid;
  margin-right: 30px;
  grid-template-columns: 1fr 3fr 1fr 3fr 1fr 3fr;
  grid-auto-rows: 50px;
  //align-items: center;
  align-items: center;
  justify-items: stretch
}
.el-form-item{
  margin: auto;
  width: 100%;
}
span{
  font-size: 14px;
  //margin: auto;
  text-align: right;
  padding-right: 10%;
}
.el-form-item{
  width: 100%;
}
.el-form-item__content{
  width: 100%;
}
.el-select{
  width: 100%;
}
.el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
  width: 100%;
}
.flex{
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  margin-top: 20px;
  margin-right: 30px;
}
.right{
  margin-left: auto;
  flex: 8;
  text-align: right;
}
.el-tooltip{
  flex: 4;
  text-align: center;
}
.el-form{
  border: #d3dce6 solid 1px;
  border-radius: 8px;
  margin-bottom: 20px;
  padding-top: 20px;
}
.company-news-header{
  border: #d3dce6 solid 1px;
  border-radius: 8px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  margin-bottom: 20px;
}
</style>